import { createAction } from '@reduxjs/toolkit';

export const denyMediaPermission = createAction<{ type: 'mic' | 'camera' }>(
    'chat/denyMediaPermission'
);

export const leftStage = createAction('chat/leftStage');
